import { addElementSetting, getElementSettings, setElementSettings } from './registered-settings';

export default {
  addElementSetting,
  getElementSettings,
  setElementSettings,
};
